/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StrategieUmsaetzeKumuliert
 */
export interface StrategieUmsaetzeKumuliert {
    /**
     * 
     * @type {number}
     * @memberof StrategieUmsaetzeKumuliert
     */
    jahr: number;
    /**
     * 
     * @type {number}
     * @memberof StrategieUmsaetzeKumuliert
     */
    firmaId: number;
    /**
     * 
     * @type {string}
     * @memberof StrategieUmsaetzeKumuliert
     */
    maschinenGruppe: string;
    /**
     * 
     * @type {number}
     * @memberof StrategieUmsaetzeKumuliert
     */
    prognoseGruppeId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof StrategieUmsaetzeKumuliert
     */
    werte: Array<number>;
}

/**
 * Check if a given object implements the StrategieUmsaetzeKumuliert interface.
 */
export function instanceOfStrategieUmsaetzeKumuliert(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jahr" in value;
    isInstance = isInstance && "firmaId" in value;
    isInstance = isInstance && "maschinenGruppe" in value;
    isInstance = isInstance && "prognoseGruppeId" in value;
    isInstance = isInstance && "werte" in value;

    return isInstance;
}

export function StrategieUmsaetzeKumuliertFromJSON(json: any): StrategieUmsaetzeKumuliert {
    return StrategieUmsaetzeKumuliertFromJSONTyped(json, false);
}

export function StrategieUmsaetzeKumuliertFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategieUmsaetzeKumuliert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jahr': json['jahr'],
        'firmaId': json['firmaId'],
        'maschinenGruppe': json['maschinenGruppe'],
        'prognoseGruppeId': json['prognoseGruppeId'],
        'werte': json['werte'],
    };
}

export function StrategieUmsaetzeKumuliertToJSON(value?: StrategieUmsaetzeKumuliert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jahr': value.jahr,
        'firmaId': value.firmaId,
        'maschinenGruppe': value.maschinenGruppe,
        'prognoseGruppeId': value.prognoseGruppeId,
        'werte': value.werte,
    };
}

